import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './en/common.json';
import enAuth from './en/auth.json';
import enNav from './en/nav.json';
import enAdmin from './en/admin.json';

import ukCommon from './ua/common.json';
import ukAuth from './ua/auth.json';
import ukNav from './ua/nav.json';
import ukAdmin from './ua/admin.json';

function getSavedLanguage(): string {
  try {
    const raw = localStorage.getItem('oms-language');
    if (!raw) return 'en';
    const parsed = JSON.parse(raw) as { state?: { language?: string } };
    return parsed?.state?.language ?? 'en';
  } catch {
    return 'en';
  }
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { common: enCommon, auth: enAuth, nav: enNav, admin: enAdmin },
    ua: { common: ukCommon, auth: ukAuth, nav: ukNav, admin: ukAdmin },
  },
  lng: getSavedLanguage(),
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

export default i18n;
